import React from 'react';
import { CreateAdProvider } from '../../context/CreateAdContext';
import CreateAd from './CreateAd';
import AiChatPanel from '../AiChatBot/AiChatPanel';

const CreateAdWithAI = ({ isPremium, shopifyProduct = null }) => (
  <CreateAdProvider>
    <div className="flex gap-4 items-start">

      {/* Chat panel — sticky so it stays in view while the form scrolls */}
      <div
        className="w-[360px] flex-shrink-0 sticky top-0 rounded-xl border border-gray-200 overflow-hidden flex-col hidden md:flex"
        style={{ height: 'calc(100vh - 100px)' }}
      >
        <AiChatPanel shopifyProduct={shopifyProduct} />
      </div>

      {/* Campaign form */}
      <div className="flex-1 min-w-0">
        <CreateAd aiMode isPremium={isPremium} />
      </div>

    </div>
  </CreateAdProvider>
);

export default CreateAdWithAI;
